import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  FormHelperText,
} from "@chakra-ui/react";
const FirstName = ({ options, formik }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const hasError = formik.touched.firstName && formik.errors.firstName;
  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="firstName" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <Input
        size="sm"
        id="firstName"
        name="firstName"
        type="text"
        placeholder={options.placeholder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.firstName}
      />
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.firstName}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default FirstName;
